import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/services";
import { useTenant } from "./useTenant";

interface IntegrationRow {
  provider: string;
  is_active: boolean | null;
  metadata: Record<string, unknown> | null;
  expires_at: string | null;
  payment_methods: string[] | null;
}

export function useAllIntegrationsStatus() {
  const { tenant } = useTenant();

  return useQuery<IntegrationRow[]>({
    queryKey: ["integrations-status", tenant?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("integrations")
        .select("provider, is_active, metadata, expires_at, payment_methods")
        .eq("tenant_id", tenant!.id);

      if (error) throw error;
      return (data ?? []) as IntegrationRow[];
    },
    enabled: !!tenant?.id,
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 30,
  });
}
